export enum MetodikaStatus {
    NotFound = 'Not found',
    Draft = 'Draft',
    Pending = 'Pending',
    Sent = 'Sent',
    Unsent = 'Unsent'
}